import { INTERNAL_SCHEMA_VERSION } from "../domain/common";
import type { AuditEvent } from "../domain/types";

export function createAuditEvent(input: {
  entityType: string;
  entityId: string;
  action: AuditEvent["action"];
  actor: AuditEvent["actor"];
  reason: string;
  changedFields?: string[];
  now?: string;
}): AuditEvent {
  return {
    id: crypto.randomUUID(),
    schemaVersion: INTERNAL_SCHEMA_VERSION,
    occurredAt: input.now ?? new Date().toISOString(),
    entityType: input.entityType,
    entityId: input.entityId,
    action: input.action,
    actor: input.actor,
    reason: input.reason,
    changedFields: input.changedFields ?? [],
    containsPrivateText: false,
  };
}
